import _ from "lodash";
import React from "react";
import { Link } from "react-router-dom";
import useWeek from "../../hooks/queryResults/useWeek";
import styled from "styled-components";
import Loading from "../ui/Loading";

const StyledDiv = styled.div`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0 auto;
  max-width: 40rem;
  justify-content: space-between;
  cursor: default;

  & div {
    padding: 0.25rem 0;
  }

  & a {
    text-decoration: none;
  }

  & span {
    padding: 0.5rem;
    margin: 0;
  }

  & div.link:not(.selected) > span {
    cursor: pointer;
  }

  & .off {
    color: #aaa;
  }

  & .off.selected,
  .off:hover {
    color: #666;
    background: #aaa;
  }

  & div.link:not(.selected) {
    cursor: pointer;
  }

  & div.link.selected,
  div.link:hover {
    background: white;
    color: blue;
  }

  // & li.playoffs {
  //   background: #57abff;
  // }

  & .playoffs.selected {
    background: #b3ffff;
    color: blue;
  }
`;

export default function WeekLinksBar({ path }) {
  const {
    selectedWeek,
    seasonStartWeek,
    playoffsStartWeek,
    numPlayoffWeeks,
    totalNumWeeks,
  } = useWeek();

  const loaded = !!selectedWeek;

  if (!loaded) return <Loading />;

  let weeks = _.range(1, totalNumWeeks + 1);

  return (
    <StyledDiv>
      <div>
        <span>Week:</span>
      </div>
      {weeks.map((week) => {
        const isSelected = week === selectedWeek;
        const isPlayoffs =
          week >= playoffsStartWeek &&
          week < playoffsStartWeek + numPlayoffWeeks;
        const isOff =
          week < seasonStartWeek || week >= playoffsStartWeek + numPlayoffWeeks;

        let classNames = ["link"];
        if (isPlayoffs) classNames.push("playoffs");
        if (isOff) classNames = ["off"];
        if (isSelected) classNames.push("selected");

        let weekLink = <span>{week}</span>;
        if (!isSelected) {
          const weekForLink = "wk-" + `0${week}`.substr(-2);
          const linkPath = path.replace(":week", weekForLink);
          weekLink = <Link to={linkPath}>{weekLink}</Link>;
        }

        return (
          <div key={week} className={classNames.join(" ")}>
            {weekLink}
          </div>
        );
      })}
    </StyledDiv>
  );
}
